import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _excluded = ["to", "label", "eventLabel", "as", "newTab"],
    _excluded2 = ["to", "newTab", "className", "eventLabel", "as", "label"];
import React from 'react';
import ReactGA from 'react-ga';
import { ChildrenPropType } from '../../services/proptypes';

var OutboundLink = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(OutboundLink, _React$Component);

  function OutboundLink(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.sendOutboundLinkEvent = _this.sendOutboundLinkEvent.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = OutboundLink.prototype;

  _proto.getExtraneousProps = function getExtraneousProps() {
    var _this$props = this.props,
        to = _this$props.to,
        label = _this$props.label,
        eventLabel = _this$props.eventLabel,
        as = _this$props.as,
        newTab = _this$props.newTab,
        rest = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return rest;
  };

  _proto.createContainerProps = function createContainerProps() {
    var _this$props2 = this.props,
        to = _this$props2.to,
        newTab = _this$props2.newTab,
        className = _this$props2.className,
        eventLabel = _this$props2.eventLabel,
        as = _this$props2.as,
        label = _this$props2.label,
        rest = _objectWithoutPropertiesLoose(_this$props2, _excluded2);

    var linkProps = newTab ? {
      href: to,
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {
      href: to
    };
    return _extends({}, linkProps, rest, {
      className: className,
      onClick: this.sendOutboundLinkEvent
    });
  };

  _proto.sendOutboundLinkEvent = function sendOutboundLinkEvent() {
    ReactGA.outboundLink({
      label: this.createLabel()
    }, function () {
      return null;
    });
  };

  _proto.createLabel = function createLabel() {
    var _this$props3 = this.props,
        label = _this$props3.label,
        eventLabel = _this$props3.eventLabel,
        children = _this$props3.children,
        to = _this$props3.to;
    var childrenLabel = typeof children === 'string' ? children : null;
    return eventLabel || label || childrenLabel || to;
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        label = _this$props4.label,
        as = _this$props4.as,
        children = _this$props4.children;

    var elementProps = _extends({}, this.createContainerProps(), {
      children: children || label
    });

    return /*#__PURE__*/React.createElement(as, elementProps);
  };

  return OutboundLink;
}(React.Component);

export { OutboundLink as default };
OutboundLink.defaultProps = {
  eventLabel: '',
  label: '',
  as: 'a',
  newTab: true,
  className: '',
  children: null
};